import { Component } from "vue-property-decorator";
import { Getter, State, Mutation, Action } from "vuex-class";
import BasePage from "@/views/BasePage/BasePage";
import { VueTelInput } from "vue-tel-input";
import CodeInput from "@/components/codeInput/codeInput";
import { configService } from "@/settings/api-url";
import Loading from "@/components/loading/loading";
import Alert from "@/components/alert/alert";

@Component({
  components: {
    VueTelInput,
    CodeInput,
    Loading,
    Alert
  }
})
export default class LoginCellCode extends BasePage {
  // Actions
  @Action action_postVerifyCodeOnly;
  @Action action_getCreateCodeCell;
  @Action action_getLoginCodeCellWhatsapp;
  @Action action_getLoginCodeCell;
  @Action action_postLoginCode;
  @Action action_getUser;
  @Action action_getCreateCodeCellWhatsapp;

  // Getters
  @Getter getUser;
  @Getter getPathTemporal;
  @Getter getLoginHelper;

  // Mutations
  @Mutation PATH_TEMPORAL;
  @Mutation LOGIN_HELPER;

  isSms = false;
  isWhatsapp = false;

  cellphoneValue = "";
  isLogin = false;
  code = "";
  isConfirmation = false;
  loading = false;

  /* Alert Modal*/
  showAlert = false;

  get getMainTitle() {
    let response = "Verifica tu número de celular";
    if(!this.isLogin) {
      response = "Regístrate con tu celular";
    }
    return response;
  }

  get getLoginMessage() {
    let response = "";
    if(this.isWhatsapp) {
      response = "Hemos enviado un código de verificación a tu WhatsApp." +
      " Por favor, escríbelo a continuación:";
    } else if (this.isSms) {
      response = "Hemos enviado un código de verificación a tu celular." +
      " Por favor, escríbelo a continuación:";
    } else if (!this.isLogin) {
      response = "Para validar tu identidad te enviaremos un código de verificación."+ 
      " Selecciona el medio por el cual deseas recibirlo: ";
    } else {
      response = "¿Cómo deseas recibir su código? "
    }
    return response;
  }

  mounted() {
    if (
      this.getLoginHelper &&
      this.getLoginHelper.isLogin !== null &&
      this.getLoginHelper.isLogin !== undefined &&
      this.getLoginHelper.cellphoneValue
    ) {
      this.isLogin = this.getLoginHelper.isLogin;
      
      this.cellphoneValue = this.getLoginHelper.cellphoneValue;
    } else {
      this.LOGIN_HELPER(null);
      this.$router.replace({ name: "login" });
    }
  }

  get getValid() {
    if (this.loading) return true;
    else return !this.isConfirmation;
  }

  async _send() {
    this.loading = true;
    if (!this.isLogin) {
      this._validationCodeNewUser();
    } else {
      this._normalValidation();
    }
    this.loading = false;
  }

  async _validationCodeNewUser() {
    if (this.isConfirmation) {
      try {
        await this.action_postVerifyCodeOnly({
          cellphone: this.cellphoneValue,
          code: this.code
        });
        const helper = {...this.getLoginHelper, validated: true};
        this.LOGIN_HELPER(helper);
        this.$router.push({
          name: "loginRegister",
          params: { cellPhone: this.cellphoneValue }
        });
      } catch (error) {
        this.$swal({
          title: "¡Error!",
          text: "¡Ups! Hubo un error validando tu teléfono. Por favor, intenta de nuevo." + error
        });
      }
    }
  }

  async _normalValidation() {
    if (this.isConfirmation) {
      try {
        await this.action_postLoginCode({
          cellphone: this.cellphoneValue,
          confirmation_code: this.code
        });
        await this.action_getUser();
        if (this.getUser.university) {
          this.LOGIN_HELPER(null);
          this._routeLogin();
        } else {
          this.$router.push({ name: "loginRegister" });
        }
      } catch (e) {
        this.showAlert = true;
      }
    }
  }

  _routeLogin() {
    if (this.getPathTemporal) {
      this.$router.replace(this.getPathTemporal);
      this.PATH_TEMPORAL(null);
    } else {
      this.$router.replace({ name: "root" });
    }
  }

  _onChange(val) {
    if (val.length < 4) this.isConfirmation = false;
  }

  // si estan lleno los campos cambia a estado comleto
  _onComplete(val) {
    if (val) {
      this.isConfirmation = true;
      this.code = val;
    }
  }

  async _resend() {
    if (!this.loading) {
      this.loading = true;
      if (this.isWhatsapp) {
        await this._requestWhatsAppCode();
      } else {
        await this._requestSMSCode();
      }
      this.loading = false;
    }
  }

  async _requestWhatsAppCode() {
    this.loading = true;
    try {
      if(this.isLogin) {
        await this.action_getLoginCodeCellWhatsapp(this.cellphoneValue); // users/get_wa_link?cellphone=123
      } else {
        await this.action_getCreateCodeCellWhatsapp(this.cellphoneValue);
      }
      this.isWhatsapp = true;
      this.isSms = false;
      this.loading = false;
    } catch (error) {
      this.$swal({
        title: "¡Error!",
        text: "¡Ups! Hubo un error solicitando tu código de verificación. Por favor, intenta de nuevo." + error
      });
      this.loading = false;
    }
  }

  async _requestSMSCode() {
    this.loading = true;
    try {
      if(this.isLogin) {
        await this.action_getLoginCodeCell(this.cellphoneValue); // users/get_sms_code?cellphone=123456
      } else {
        await this.action_getCreateCodeCell(this.cellphoneValue); // users/get_sms_code?cellphone=$123&is_new_user=true
      }
      this.isSms = true;
      this.isWhatsapp = false;
      this.loading = false;
    } catch (error) {
      this.$swal({
        title: "¡Error!",
        text: "¡Ups! Hubo un error solicitando tu código de verificación. Por favor, intenta de nuevo." + error
      });
      this.loading = false;
    }
  }

  _returnLogin() {
    this.loading = true;
    setTimeout(() => {
      this.$router.replace({ name: 'login' });
      this.loading = false;
    }, 1000);
  }

  /* Alert Modal*/
  _resendCodeAlert() {
    this._resend();
    this._closeModal();
  }

  _closeModal() {
    this.showAlert = false;
  }

  goToMarketplace() {
    this.$router.replace({ name: 'root' });
  }
}
